module.exports = "/images/msg-error.svg?9b32a17dcd2ea9bd95ed336128e532bb";